export default {
  title: "E-mailadressen",
  input: {
    title: "E-mailadres {{action}}",
    email: {
      label: "E-mailadres"
    },
    type: {
      label: "Type"
    }
  },
  view: {
    noItems: {
      title: "Nog geen e-mailadressen",
      text: "Klik om een e-mailadres toe te voegen."
    }
  }
}
